/* 
This is a helper file for segment usage which does 2 things.

1. Uses the no op pattern for non-prod environments.
2. Reduces the dependency on the window object since consumers of this file
   don't need to know where the actual analytics object is.
*/

import { isProduction } from "config";

const noOpAnalytics = {
  Integrations: {},
  require: "",
  VERSION: "",
  use: () => {},
  addIntegration: () => {},
  addSourceMiddleware: () => {},
  addIntegrationMiddleware: () => {},
  addDestinationMiddleware: () => {},
  initialize: () => {},
  init: () => {},
  setAnonymousId: () => {},
  add: () => {},
  identify: (userId: string, traits?: Object) => {
    // eslint-disable-next-line no-console
    console.log("identify event", userId, " with properties", traits);
  },
  user: () => {},
  group: () => {},
  track: (event: string, properties?: Object) => {
    // eslint-disable-next-line no-console
    console.log("tracked event", event, " with properties", properties);
  },
  trackClick: () => {},
  trackLink: () => {},
  trackSubmit: () => {},
  trackForm: () => {},
  page: (name?: string, properties?: Object) => {
    // eslint-disable-next-line no-console
    console.log("page event", name, " with properties", properties);
  },
  alias: () => {},
  ready: () => {},
  timeout: () => {},
  debug: () => {},
  reset: () => {},
  normalize: () => {},
  noConflict: () => {},
};

let analytics;

if (isProduction()) {
  analytics = window.analytics;
} else {
  analytics = noOpAnalytics;
}

export default analytics as SegmentAnalytics.AnalyticsJS;
